import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const Seo = ({ description = '', lang = 'en', meta = [], title, image }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            image
          }
        }
      }
    `
  )

  const defaultTitle = site.siteMetadata?.title
  const metaDescription = description || site.siteMetadata.description
  const metaImage = image || site.siteMetadata.image
  
  return <>
    { title && <><title>{ title }</title> <meta property="og:title" content={title} /> <meta name="twitter:title" content={title} /></> }
    <meta name="description" content={metaDescription} />
    <meta property="og:description" content={metaDescription} />
    <meta name="twitter:description" content={metaDescription} />
    <meta name="image" content={metaImage} />
    <meta property="og:image" content={metaImage} />
    <meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary_large_image" />
  </>
}

export default Seo
